import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    updateJobCheckpoint(ctx, { checkpointId, checkpointData }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/checkpoints/${checkpointId}`, checkpointData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
